import { useMediaQuery } from "@mediamonks/react-kit";

export function useViewportStateMedium(): boolean {
  return useMediaQuery("(min-width: 720px)", false);
}
